<app-title-bar titleText="i18n.base.forgot-password.header"></app-title-bar>
<div class="row">
  <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
    @if (!forgotPasswordSuccess) {
      <form id="forgotPasswordForm" [formGroup]="forgotPasswordForm" autocomplete="on">
        <p>
          {{ "i18n.base.forgot-password.info" | translate }}
          <ejs-tooltip id='tooltip' content="{{ 'i18n.base.forgot-password.tooltip' | translate }}">
            <span class="icon-information"></span>
          </ejs-tooltip>
        </p>
        <div class="form-group">
          <label for="userName">{{ "i18n.base.forgot-password.email" | translate }}</label>
          <input id="userName" name="username" type="text" autocomplete="username" class="form-control" formControlName="userName" appRequired>
          <app-error-messages [control]="formFields.userName"></app-error-messages>
        </div>
        <div class="text-end">
          <a type="button" class="btn btn-secondary" [routerLink]="loginRoute">
            {{ "i18n.base.forgot-password.back-button" | translate }}
          </a>
          <button type="submit" class="btn btn-primary ms-2" (click)="formSubmit()" [disabled]="!forgotPasswordForm.valid">
            {{ "i18n.base.forgot-password.submit-button" | translate }}
          </button>
        </div>
      </form>
    }
    @if (forgotPasswordSuccess) {
      <div>
        <p class="success-message"><span class="e-icons icon-checkmark me-1"></span>{{ "i18n.base.forgot-password.success-info" | translate }}</p>
      </div>
    }
  </div>
</div>
